import { createFileRoute } from "@tanstack/react-router";
import { Error500Component } from "@/components/Error";

export const Route = createFileRoute("/_error/500")({
	component: Error500Component,
});
